import type { TOC } from '@ember/component/template-only';
import { PhCheckCircle } from 'ember-phosphor-icons';

interface SelectableCardSignature {
  Args: {
    description: string;
    isSelected: boolean;
    label: string;
    onChange: (value: string) => void;
    value: string;
    disabled?: boolean;
  };
  Blocks: {
    label: [];
  };
}

/** Single-selection card that calls @onChange with @value when clicked. */
const SelectableCard: TOC<SelectableCardSignature> = <template>
  <button
    type="button"
    role="radio"
    aria-checked={{@isSelected}}
    {{on "click" (fn @onChange @value)}}
    class="tio-card tio-card--radius-compact tio-card--elevation-card tio-card--padding-sm tio-selectable-card
      {{if @isSelected 'tio-selectable-card--selected'}}"
    data-test={{@value}}
    disabled={{@disabled}}
  >
    <div class="flex-1 text-left">
      <span class="tio-text-sm-medium">
        {{#if (has-block "label")}}
          {{yield to="label"}}
        {{else}}
          {{@label}}
        {{/if}}
      </span>
      <span class="mt-2 text-sm tio-fg-muted">{{@description}}</span>
    </div>
    {{! Always laid out, hidden when unselected: rendering on selection reflowed the card. }}
    <span
      class="tio-selectable-card__selected-icon ml-2 shrink-0 {{unless @isSelected 'invisible'}}"
    >
      <PhCheckCircle @size="24" role="presentation" aria-hidden="true" />
    </span>
  </button>
</template>;

export default SelectableCard;
